import { ApplicationRef } from '@angular/core';
import { BaseSecurityPageModule } from 'SecuritiesApp/ts/apps/base-security-page/app.module';
import { HoldingsCategoriesTableModule } from 'SecuritiesApp/ts/features/holdings-categories-table/holdings-categories-table.module';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { HoldingsCategoriesTableComponent } from 'SecuritiesApp/ts/features/holdings-categories-table/holdings-categories-table.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import * as i0 from "@angular/core";
export class MutualFundsHoldingsCategorizeModule {
    ngDoBootstrap(appRef) {
        appRef.bootstrap(HoldingsCategoriesTableComponent);
        appRef.bootstrap(TopBarNavComponent);
        appRef.bootstrap(SideMenuComponent);
        appRef.bootstrap(SecurityHeaderControlComponent);
    }
}
MutualFundsHoldingsCategorizeModule.ɵfac = function MutualFundsHoldingsCategorizeModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsHoldingsCategorizeModule)(); };
MutualFundsHoldingsCategorizeModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsHoldingsCategorizeModule });
MutualFundsHoldingsCategorizeModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseSecurityPageModule, HoldingsCategoriesTableModule] });
